var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToCreatingAnExperiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.793 48.097c0-.212.053-.37.212-.529l3.968-3.913c.769-.763 5.001 3.731 4.339 4.336l-3.916 3.913c-.305.305-.747.254-1.058 0l-3.28-3.278a.65.65 0 0 1-.265-.53Z",
    fill: "#707B7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.894 30.544a22.457 22.457 0 0 1 6.614-15.915c8.783-8.83 23.069-8.83 31.905-.053 8.783 8.777 8.783 23.053 0 31.883-8.783 8.778-23.07 8.778-31.905 0a22.458 22.458 0 0 1-6.614-15.915Zm3.704 0c0-4.811 1.852-9.676 5.502-13.324 7.355-7.402 19.313-7.402 26.72-.053 7.355 7.402 7.355 19.352 0 26.701-7.354 7.35-19.312 7.35-26.667 0-3.703-3.7-5.555-8.512-5.555-13.324Z",
    fill: "#707B7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.599 30.545c0-4.812 1.851-9.676 5.502-13.325 7.355-7.402 19.313-7.402 26.72-.052 7.355 7.402 7.355 19.352 0 26.701-7.354 7.35-19.312 7.35-26.667 0-3.704-3.7-5.555-8.513-5.555-13.324Z",
    fill: "#2E385F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 67.61c0-1.428.582-2.803 1.587-3.808l17.831-17.818c.306-.306.748-.255 1.058 0l6.561 6.556c.318.317.318.793 0 1.058l-17.83 17.818C13.813 74.808 8 72.388 8 67.61Z",
    fill: "#9FAB5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.532 61.86 3.386-3.383 7.606 7.627-3.386 3.383-7.606-7.627ZM57.925 23.034c-4.018-4.2-10.825-4.05-14.89.012-.961.962-2.623.267-2.623-1.067 0-1.049 1.328-2.079 2.11-2.604 1.406-.942 3.091-1.631 4.732-2.026 4.775-1.15 9.326.072 12.82 3.563.414.414.58.988.381 1.549-.372 1.051-1.73 1.41-2.53.573Z",
    fill: "#475076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToCreatingAnExperiment);
export default __webpack_public_path__ + "static/media/how-to-creating-an-experiment.bc67c859fda54e49769ee10d1a695320.svg";
export { ForwardRef as ReactComponent };